// extracted by mini-css-extract-plugin
module.exports = {"tile":"_4db662b0","info":"_7ac5530a"};